const Shimmer = () => {
  const cards = []
  for (let i = 0; i < 35; i++) {
    cards.push(
      <div
        key={i}
        className="shimmer-card rounded-lg p-4 mx-2 my-4 w-[200px] h-[300px] border-solid border-b-gray-600 bg-slate-500 shadow-lg"
      >
        {/* Additional content can go here */}
      </div>
    )
  }
  return <div className="shimmer-container flex flex-wrap">{cards}</div>
}
export default Shimmer
